import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import DetailBus from '../components/DetailCarte'
import ProchainPassage from "../components/ProchainPassage";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:stopName',
      name: 'ProchainPassage',
      component: ProchainPassage
    },
    {
      path: '/carte/:tripId/:stopId/:sequence',
      name: 'detailBus',
      component: DetailBus
    },
  ]
})


/*
router.afterEach((to, from) => {
  window.dataLayer = window.dataLayer || []

  gtag('event', 'page_view', {
    page_title: to.name,
    page_location: to.fullPath,
    page_path: '/#' + to.path,
    send_to: 'UA-67734949-5'
  })
  gtag('js', new Date())
  gtag('config', 'UA-67734949-5')
})
*/
export default router



// WEBPACK FOOTER //
// ./src/router/index.js